import api from "../services/api";

import { eStatus, IConsulta, IConsultaContador, IRevendedor, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IConsultaListModel extends Pick<IConsulta, "id" | "dataConsulta" | "cpf" | "nome" | "status"> {
    representante: string;
}

export interface IConsultaResumoRepresentante {
    aprovados: number;
    reprovados: number;
}

interface IConsultaContadorPutModel {
    limite: number;
}

interface ILimitAvailableResponse {
    limit: number;
    available: number;
}

interface IConsultaRequestModel {
    cpf: string;
    dataNascimento: string;
}

interface IConsultaResponseModel {
    cadastroId: string;
    consulta: IConsulta;
    message: string;
    status: eStatus;
}

interface IApproveResponseModel {
    revendedor: IRevendedor;
    message: string;
}

interface IUpdateLimitResponseModel {
    contador: IConsultaContador;
    message: string;
}

interface IDisapproveResponseModel extends IApproveResponseModel {

}

interface ITrustApproveResponseModel extends IApproveResponseModel {

}

class ConsultaRepository {
    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IConsultaListModel>> => {

        const response = await api.get<ISearchResponse<IConsultaListModel>>("consulta", {
            params: {
                search: searchRequest.search,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public UpdateLimit = async (id: string, { limite }: IConsultaContadorPutModel): Promise<IUpdateLimitResponseModel> => {
        const response = await api.put<IUpdateLimitResponseModel>(`consulta/representante/${id}`, { limite });
        return response.data;
    }
    public GetResumoRepresentante = async (id: string): Promise<IConsultaResumoRepresentante> => {
        const response = await api.get<IConsultaResumoRepresentante>(`consulta/representante/${id}`);
        return response.data;
    }

    public HealthCheck = async (): Promise<boolean> => {
        const response = await api.get<boolean>(`consulta/healthcheck`);
        return response.data;
    }

    public GetById = async (id: string): Promise<IConsulta> => {
        const response = await api.get<IConsulta>(`consulta/${id}`);
        return response.data;
    }

    public LimitAvailable = async (id: string): Promise<ILimitAvailableResponse> => {
        const response = await api.get<ILimitAvailableResponse>(`consulta/limitavailable/${id}`);
        return response.data;
    }

    public Consult = async ({ cpf, dataNascimento }: IConsultaRequestModel): Promise<IConsultaResponseModel> => {
        const response = await api.post<IConsultaResponseModel>(`consulta`, {
            cpf,
            dataNascimento
        });
        return response.data;
    }

    public Approve = async (cpf: string): Promise<IApproveResponseModel> => {
        const response = await api.post(`consulta/${cpf}/approve`);
        return response.data;
    }

    public Disapprove = async (cpf: string): Promise<IDisapproveResponseModel> => {
        const response = await api.post(`consulta/${cpf}/disapprove`);
        return response.data;
    }

    public TrustApprove = async (cpf: string): Promise<ITrustApproveResponseModel> => {
        const response = await api.post(`consulta/${cpf}/trustapprove`);
        return response.data;
    }
}

const consultaRepository = new ConsultaRepository();
export default consultaRepository;
